
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"17","viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#253765","d":"M12.549 2.682h-4.63v13.204H4.63V2.682H0V.039h12.549v2.643zm1.136 11.62a1.731 1.731 0 011.075-1.61 1.79 1.79 0 01.705-.137 1.799 1.799 0 011.267.508 1.731 1.731 0 01.513 1.24 1.72 1.72 0 01-.513 1.24c-.16.156-.35.278-.568.365a1.864 1.864 0 01-.7.131 1.86 1.86 0 01-.704-.131 1.708 1.708 0 01-1.076-1.605z"}})])
          )
        }
      }
    